<template>
  <div class="view">
    <Title title="観光ポイント"/>
    <TourismEditMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import TourismEditMain from '@/components/Tourism/EditMain'

export default {
  components: {
    Title,
    TourismEditMain
  }
}
</script>
